import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "profile-icon",
  role: "img",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24",
      height: "24",
      rx: "12"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.1844 13.6304C16.942 11.8728 16.942 9.02311 15.1844 7.26548C13.4267 5.50784 10.577 5.50784 8.81941 7.26548C7.06177 9.02311 7.06177 11.8728 8.81941 13.6304C10.577 15.3881 13.4267 15.3881 15.1844 13.6304Z",
      fill: "#0F171F",
      "fill-opacity": "0.25"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.81558 19.726C5.01365 22.3375 8.30488 23.9984 11.9842 24.0038H12.0198C15.699 23.9984 18.9901 22.3376 21.1882 19.7262C19.66 17.6085 15.8664 16.3197 12.002 16.3197C8.13743 16.3197 4.34366 17.6079 2.81558 19.726Z",
      fill: "#0F171F",
      "fill-opacity": "0.25"
    }, null, -1)
  ])))
}
export default { render: render }